// Development-only logging; silent in production builds so nothing leaks to the console.
const enabled = process.env.NODE_ENV !== "production";

export const logger = {
  warn: (...args) => { if (enabled) console.warn(...args); },
  error: (...args) => { if (enabled) console.error(...args); },
};
